<template>
  <div>
    <div class="wrapper">
      <el-menu
        :default-active="activeIndex"
        background-color="#003c91"
        text-color="#ffffff"
        mode="horizontal"
        active-text-color="#ffffff"
      >
        <el-menu-item
          v-for="(item, index) in brandList"
          :key="index"
          :index="index + ''"
          @click="handleClick(item)"
        >
          <!-- <router-link v-if="item.to" :to="item.to">
            <span class="yyy">{{ item.name }}</span>
          </router-link> -->
          <a class="yyy">{{ item.name }}</a>
        </el-menu-item>
      </el-menu>

      <div class="tot pt10">
        <!--类别-->
        <!-- <catalog></catalog> -->
        <!--轮播图-->
        <!-- <slideShow :imgData="imgOptionsA"></slideShow> -->
        <notice-lists
          :tabCode="tabCode"
          :supName="supName"
          :supCode="supCode"
        ></notice-lists>
        <!--用户登录信息-->
        <showUser @getSupCode="getSupCode" :imgData="imgOptionsB"></showUser>
      </div>
      <!-- 公告列表 -->
      <!-- <notice-list :supCode="supCode"></notice-list> -->
      <!--轮播图-->
      <slideShows
        v-if="imgOptionsA && imgOptionsA.length > 0"
        :imgData="imgOptionsA"
      ></slideShows>
    </div>
    <!--公告列表-->
    <!-- <notice-item @getSupCode="getSupCode"></notice-item> -->
  </div>
</template>

<script>
// import catalog from "@/app/shop/components/catalog.vue";
// import slideShow from "@/app/shop/components/slideShow.vue";
import globalCofig from "@/setting/setting";
import slideShows from "@/app/shop/components/slideShows.vue";
import showUser from "@/app/shop/components/showUser.vue";
import noticeLists from "@/app/shop/components/noticeLists.vue";
// import noticeItem from "@/app/shop/components/noticeItem.vue";
import { qryPostersList } from "@/app/shop/api/shopping";
import { selectSubconPosters } from "@/app/common-modules/api/topnav";
import { getUserInfo1 } from "@/config/api/login";
export default {
  name: "shopping",
  components: {
    // catalog,
    // slideShow,
    showUser,
    slideShows,
    noticeLists
    // noticeItem
  },
  data() {
    return {
      imgOptionsA: [],
      imgOptionsB: [],
      brandList: [
        {
          name: this.$t("page.content.menu1"), //首页
          type: 1,
          to: "/"
        },
        {
          name: "招标公告", //招标公告
          // name: this.$t("page.content.menu6"), //招标公告
          type: 2
        },
        {
          name: "补遗/流标公告", //补遗/流标公告
          // name: this.$t("page.content.menu7"), //补遗/流标公告
          type: 3
        },
        {
          name: "评标/评审结果公示", //评标/评审结果公示
          // name: this.$t("page.content.menu8"), //评标/评审结果公示
          type: 4
        },
        {
          name: "中标结果", //中标结果
          // name: this.$t("page.content.menu9"), //中标结果
          type: 5
        },
        {
          name: "电子投标", //电子投标
          // name: this.$t("page.content.menu10"), //电子投标
          type: 10
        },
        {
          name: "信息维护", //信息维护
          // name: this.$t("page.content.menu11"), //信息维护
          type: 11
        }
        // {
        //   name: this.$t("page.content.menu2"), //集中采购
        //   type: 2
        // },
        // {
        //   name: this.$t("page.content.menu3"), //区域联采
        //   type: 3
        // },
        // {
        //   name: this.$t("page.content.menu4"), //分包商注册
        //   type: 4,
        // },
        // {
        //   name: this.$t("page.content.menu5"), //供应链金融
        //   type: 5
        // }
      ],
      supCode: "",
      supName: "",
      activeIndex: "0",
      tabCode: "1"
    };
  },
  activated() {
    this.init();
    if (this.loginInfo.name) {
      // 已登录
      this.brandList = [
        {
          name: this.$t("page.content.menu1"), //首页
          type: 1
        },
        {
          name: "招标公告", //招标公告
          type: 2
        },
        {
          name: "补遗/流标公告", //补遗/流标公告
          type: 3
        },
        {
          name: "评标/评审结果公示", //评标/评审结果公示
          type: 4
        },
        {
          name: "中标结果", //中标结果
          type: 5
        },
        {
          name: "电子投标", //电子投标
          type: 10
        }
        // {
        //   name: this.$t("page.content.menu2"), //集中采购
        //   type: 2
        // },
        // {
        //   name: this.$t("page.content.menu3"), //区域联采
        //   type: 3
        // },
        // {
        //   name: this.$t("page.content.menu4"), //分包商注册
        //   type: 4,
        // },
        // {
        //   name: this.$t("page.content.menu5"), //供应链金融
        //   type: 5
        // }
      ];
      getUserInfo1({}).then(res1 => {
        if (
          res1.data.data &&
          res1.data.data.umOrganizations &&
          res1.data.data.umOrganizations[0] &&
          res1.data.data.umOrganizations[0].appList &&
          res1.data.data.umOrganizations[0].appList.length > 0
        ) {
          let obj = "";
          for (
            let i = 0;
            i < res1.data.data.umOrganizations[0].appList.length;
            i++
          ) {
            if (
              res1.data.data.umOrganizations[0].appList[i].appId == "100066"
            ) {
              obj = JSON.stringify(
                res1.data.data.umOrganizations[0].appList[i]
              );
              break;
            }
          }
          if (obj) {
            localStorage.crmsaInfo = obj;
            this.brandList.push({
              name: "信息维护", //信息维护
              to: JSON.parse(obj).url,
              type: 11
            });
          } else {
            localStorage.crmsaInfo = "";
          }
        }
      });
      this.tabCode = "1";
    } else {
      this.brandList = [
        {
          name: "温馨提示", //首页
          type: 19
        },
        // {
        //   name: "招标公告", //招标公告
        //   type: 2
        // },
        {
          name: this.$t("page.content.menu4"), //分包商注册
          type: 14
        }
      ];
      this.tabCode = "19";
      // 清除缓存信息
      localStorage.removeItem("usedSupInfo");
      localStorage.removeItem("supInfo");
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    }
  },
  deactivated() {},
  methods: {
    handleClick(item) {
      if (item.type == 10) {
        // 投标
        window.open(
          this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
            "?CLIENT_ID=" +
            globalCofig.agentId +
            "&CALLBACK_URL=" +
            encodeURIComponent(
              `${this.$addUrlPerFix(process.env.VUE_APP_BID_URL)}/index?a=${
                globalCofig.agentId
              }`
            ),
          "_blank"
        );
      } else if (item.type == 11) {
        // 信息维护
        window.open(
          item.to,
          // this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          //   "?CLIENT_ID=" +
          //   "3EB1D859ACB784EA16323A2B4F38CAEC62DB081CB42DFD2F1C20183E4701600A" +
          //   "&CALLBACK_URL=" +
          //   encodeURIComponent(
          //     `${this.$addUrlPerFix(
          //       process.env.VUE_APP_CRMSA_URL
          //     )}?a=3EB1D859ACB784EA16323A2B4F38CAEC62DB081CB42DFD2F1C20183E4701600A`
          //   ),
          "_blank"
        );
      } else if (item.type == 14) {
        // 分包商注册
        window.open(
          this.$addUrlPerFix("sra.iccec.cn/subcontractor-registration")
        );
      } else {
        this.tabCode = String(item.type);
      }
    },

    init() {
      this.getSwipper();
      // 查询宣传海报
      qryPostersList({
        agentId: 100131,
        moudle: 1,
        pageState: 2,
        appId: 100131
      }).then(res => {
        if (res.data.code === "0") {
          // this.imgOptionsA =
          //   res.data.data.qryPostersListRspListBO[0].publicityContentBOS;
          this.imgOptionsB = res.data.data.qryPostersListRspListBO[1].publicityContentBOS.map(
            (item, index) => {
              item.width = 240;
              if (item.index === 0) {
                item.height = 40;
              } else {
                item.height = 36;
              }
              return item;
            }
          );
        }
      });
    },

    getSwipper() {
      selectSubconPosters({ type: 3 }).then(res => {
        this.imgOptionsA = res.data.data;
      });
    },

    getSupCode(val) {
      this.supCode = val.code;
      this.supName = val.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.pt10 {
  padding-top: 10px;
}
.tot {
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
}
.yyy {
  font-size: 20px;
}
/deep/ .el-menu-item {
  padding: 0 30px !important;
}
</style>
